import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideQueryService } from 'src/app/core/services/query.service';
import { CRUD_FILE_ENDPOINT, CRUD_FORM_ENDPOINT, CRUD_FORM_FLUX_ENDPOINT, crudFormStateConfig, JSON_FORM_ENDPOINT, jsonFormStateConfig } from './survey.config';
import { SurveyJsonFormService } from './services/survey-json-form.service';
import { SurveyCrudFormService } from './services/survey-crud-form.service';
import { SurveyCrudFileService } from './services/survey-crud-file.service';
import { SurveyJsonFormFluxService } from './services/survey-json-form-flux.service';
import { SurveyCrudFormFluxService } from './services/survey-crud-form-flux.service';
import { SurveyCrudFileFluxService } from './services/survey-crud-file-flux.service';

@NgModule({
  declarations: [],
  providers: [
    ...provideQueryService<any>(JSON_FORM_ENDPOINT, jsonFormStateConfig),
    ...provideQueryService<any>(CRUD_FORM_ENDPOINT, crudFormStateConfig),
    ...provideQueryService<any>(CRUD_FILE_ENDPOINT, crudFormStateConfig),
    ...provideQueryService<any>(CRUD_FORM_FLUX_ENDPOINT, crudFormStateConfig),
    SurveyJsonFormService,
    SurveyCrudFormService,
    SurveyCrudFileService,
    SurveyJsonFormFluxService,
    SurveyCrudFormFluxService,
    SurveyCrudFileFluxService

  ],
  imports: [
    CommonModule,
  ]
})
export class SurveyFormModule { }